module.exports = __webpack_public_path__ + "assets/9bc7166f831c1ace68411b2a78dec9c7.png";